export default __webpack_public_path__ + "static/media/fi_arrow-right.f4e376b6.svg";